import { HisTypeOptionIdType } from '@/pages/Onboarding/options/HisType/types';

const hisTypeNameMap: Record<HisTypeOptionIdType, string> = {
  twink: 'Harry',
  leather: 'Jason',
  clean_cut: 'Luca Moretti',
  otter: 'Mad Mixel',
  bear: 'Magnus Allen',
  geek: 'Maxim',
  trans: 'Morgan Baiad',
  pup: 'Pup',
  daddy: 'Rafael',
  queer: 'Rio',
  jock_sporty: 'Thomas',
  boy: 'Harry',
};

export function getNameByHisType(
  hisType: HisTypeOptionIdType | null | undefined,
): string {
  if (!hisType) return 'Name';
  return hisTypeNameMap[hisType] || 'Name';
}
